import moment from "moment";
import Swal from "sweetalert2";

// create array of fill a certein item
export const fill = (fillValue, count) => {
  let ans = [];
  for (let index = 0; index < count; index++) {
    ans.push(fillValue);
  }
  return ans;
};

// create array of days in months
export const monthHas_N_days = (month, year) => {
  let data = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) data[1]++;
  return data[month];
};

// create array using range
export const range = (start, end) => {
  let ans = [];
  for (let index = start; index <= end; index++) {
    ans.push(index);
  }
  return ans;
};

export const ModalInvoice = (item, theme) => {
  Swal.fire({
    confirmButtonText: "Okay",
    background: theme === "dark" ? "#111827" : "", 
    html: `
        <div class="p-4 bg-front dark:dark-bg-front box">
            <h2 class="text-lg font-semibold mb-4">Invoice ${item.id}</h2>
            <h2 class="text-lg font-light border p-2 rounded bg-green-200  mb-4">Thank You for the Order</h2>
            <div class="mb-2">
                <p>Date: ${moment(new Date()).format("DD/MM/YYYY")}</p>
            </div>
            <table class="w-full mb-4">
                <thead>
                    <tr>
                        <th class="text-left">Description</th>
                        <th class="text-right">Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr  class="border-t">
                        <td  class="text-left py-3">${item.product_name} - ${
      item.order_name
    } x 1</td>
                        <td class="text-right py-3">${
                          item.order_price
                        } &#2547;</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="border-t">
                        <td class="text-right font-semibold">Total:</td>
                        <td class="text-right">${item.order_price} &#2547;</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    `,
    showConfirmButton: true,
  });
};
